import actionCreatorFactory from 'typescript-fsa';
import { FB_NAMESPACE } from './constants';
const actionCreator = actionCreatorFactory(FB_NAMESPACE);
export const setFacebookSdkLoadingStart = actionCreator('LOADING_SDK');
export const setFacebookSdkLoadingEnd = actionCreator('LOADING_SDK_ENDED');
export const setFacebookFetchToken = actionCreator('FETCHING_TOKEN');
export const setFacebookFetchTokenEnd = actionCreator('FETCHING_TOKEN_ENDED');
export const setFacebookToken = actionCreator('SET_TOKEN');
export const setFacebookUserEmailTo = actionCreator('FACEBOOK_USER_EMAIL_TO_NEW_EMAIL');
export const setFacebookUserEmailUpdateFailed = actionCreator('FACEBOOK_USER_EMAIL_UPDATE_FAILED');
//# sourceMappingURL=actions.js.map